import { Text, View, ScrollView, TouchableOpacity } from "react-native";
import { useRouter, useLocalSearchParams } from "expo-router";
import React from "react";
import moment from "moment";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function detailprint() {
  const router = useRouter();
  const { item: itemParams } = useLocalSearchParams();
  const { t } = useLanguage();

  const item =
    typeof itemParams === "string" ? JSON.parse(itemParams) : itemParams;

    // console.log("item", JSON.stringify(item, null, 2));

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[90%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
            <Text className="text-2xl font-kanit py-2">
              {/* รายละเอียดเพิ่มเติม */}
              {t("detail_order")}
            </Text>
          </View>

          <View className="w-full flex-1 pt-2">
            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* ชื่อ */}
                {t("name")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.materialDesc ? item?.materialDesc : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* Order No. */}
                {t("order_number")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.order_number ? item?.order_number : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* Matcode */}
                {t("matcode")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.materialNo ? item?.materialNo : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* จำนวน */}
                {t("quantity")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.quantity ? item?.quantity : t("no_data")}{" "}
                  {item?.unit ? item?.unit : ""}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* หมายเลขภาชนะ */}
                {t("container_number")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.returnId ? item?.returnId : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* สถานที่ */}
                {t("storage_location")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.machineNo ? item?.machineNo : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* ผู้ร้องขอ */}
                {t("employee_request")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.employee_product_name ? item?.employee_product_name : t("no_data")}
                </Text>
              </View>
            </View>

            <View className="w-full items-start justify-start py-2">
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {/* วัน-เวลาที่ร้องขอ */}
                {t("date_time_request")}
              </Text>
              <View className="w-full flex-row items-center justify-between py-2 rounded-md bg-gray-100 px-4">
                <Text className="text-xl font-kanit">
                  {item?.createdAt
                    ? moment(item?.createdAt).format("DD/MM/YYYY HH:mm")
                    : t("no_data")}
                </Text>
              </View>
            </View>
          </View>

          <View className="w-full items-center justify-center py-2 border-t pt-5 border-gray-300">
            <TouchableOpacity
             onPress={() =>
              router.push({
                pathname: "/screens/print_order",
                params: {
                  item: JSON.stringify(item),
                },
              })
            }
              className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
            >
              <Text className="text-white text-lg font-kanit">
                {/* พิมพ์ใบชี้บ่งผลิตภัณฑ์ */}
                {t("print_label")}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    </>
  );
}
